/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { PlaceholderText } from 'sarsaparilla';

import styles from './ResultsListSkeleton.module.scss';

export function PlaceholderList() {
    return (
        <div className={styles.cardList}>
            {Array.from({ length: 4 }).map((_, index) => (
                <PlaceholderCard key={index} />
            ))}
        </div>
    );
}

function PlaceholderCard() {
    return (
        <div className={styles.card}>
            <Placeholder height="82px" width="136px" style={{ borderRadius: '8px' }} />
            <div className={styles.cardContent}>
                <PlaceholderText lines={1} fontSize={14} lineHeight={24} width="160px" />
                <PlaceholderText lines={1} fontSize={12} lineHeight={20} />
            </div>
        </div>
    );
}

interface PlaceholderProps extends React.HTMLAttributes<HTMLDivElement> {
    height: string;
    width?: string;
    borderRadius?: string;
    screenReaderText?: string;
    style?: React.CSSProperties;
}

function Placeholder({
    height,
    width,
    borderRadius,
    style,
    screenReaderText,
    ...rest
}: PlaceholderProps) {
    return (
        <div
            data-component="Placeholder"
            style={{
                height,
                borderRadius,
                width,
                ...style,
            }}
            {...rest}
        >
            {screenReaderText && <span className="rec-sr-only">{screenReaderText}</span>}
        </div>
    );
}
